export const API_CONFIG = {
  //BASE_URL: 'http://localhost:5115/api/v1',
  BASE_URL: 'http://157.230.164.247:5000/api/v1',
  TOKEN: null,
  ENDPOINTS: {
    ROLES: '/Roles',
    USERS: '/Usuario',
    EMPRESA: '/Empresa',
    SUCURSAL: '/Sucursal',
    CIUDAD: '/Ciudades',
    CATEGORIA: '/Categoria',
    PRODUCTO: '/Producto',
    DRIVER: '/Driver',
    CLIENTE: '/Cliente',
    DIRECCION: '/Direccion',
    PARAMETROS: '/Parametros',
    ESTADOSUCURSAL: '/EstadoSucursal',
    VENTAS: '/Ventas',
    PAGOCLIENTE: '/PagoCliente',
    DESCUENTO: '/Descuento',
    REPORTE_ORDENES_SUCURSAL: '/Ventas/sucursal/ordenes-pasadas/',
    OPCIONES_PRODUCTO: '/OpcionesProducto', // ✅ NUEVO
  }
};
 
export const ROLE_STATES  = { ACTIVE: 'ACTIVO', INACTIVE: 'INACTIVO' };
export const USER_STATES  = { ACTIVE: 'ACTIVO', INACTIVE: 'INACTIVO' };
 
export const MESSAGES = {
  SUCCESS: { CREATE: 'Elemento creado exitosamente', UPDATE: 'Elemento actualizado exitosamente', DELETE: 'Elemento eliminado exitosamente', LOAD: 'Datos cargados correctamente' },
  ERROR:   { GENERIC: 'Ha ocurrido un error. Intente nuevamente.', NETWORK: 'Error de conexión. Verifique su conexión a internet.', NOT_FOUND: 'Elemento no encontrado', VALIDATION: 'Por favor verifique los datos ingresados', UNAUTHORIZED: 'No tiene permisos para realizar esta acción', SERVER: 'Error del servidor. Intente más tarde.' },
  WARNING: { UNSAVED_CHANGES: 'Tiene cambios sin guardar. ¿Desea continuar?', DELETE_CONFIRM: '¿Está seguro de que desea eliminar este elemento?' }
};
 
export const VALIDATION = {
  USER: { MIN_USERNAME_LENGTH: 3, MIN_PASSWORD_LENGTH: 3, MAX_USERNAME_LENGTH: 50, MAX_PASSWORD_LENGTH: 100 },
  ROLE: { MIN_NAME_LENGTH: 2, MAX_NAME_LENGTH: 50, MAX_DESCRIPTION_LENGTH: 500 }
};